import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Badge, de } from "@/components/qm/shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fehler = (e) => toast.error(e?.response?.data?.detail || "Fehler");
const ST = { gueltig: ["gültig", "gruen"], laeuft_ab: ["läuft bald ab", "gelb"], abgelaufen: ["abgelaufen", "rot"], fehlt: ["Zeitraum fehlt", "grau"] };

export const MassnahmenZulassung = () => {
  const [liste, setListe] = useState([]);
  const laden = useCallback(() => axios.get(`${API}/massnahmen-zulassung`).then((r) => setListe(r.data)).catch(fehler), []);
  useEffect(() => { laden(); }, [laden]);
  const aendern = (z) => {
    const massnahmenummer = window.prompt("Maßnahmenummer:", z.massnahmenummer || ""); if (massnahmenummer === null) return;
    const azav_zulassung_nummer = window.prompt("AZAV-Zertifikat / Zulassungsnummer:", z.azav_zulassung_nummer || ""); if (azav_zulassung_nummer === null) return;
    const zulassung_von = window.prompt("Zulassung von (TT.MM.JJJJ):", de(z.zulassung_von)); if (zulassung_von === null) return;
    const zulassung_bis = window.prompt("Zulassung bis (TT.MM.JJJJ):", de(z.zulassung_bis)); if (zulassung_bis === null) return;
    axios.put(`${API}/massnahmen-zulassung/${z.kurs_id}`, { massnahmenummer, azav_zulassung_nummer, zulassung_von, zulassung_bis })
      .then(() => { toast.success("Gespeichert"); laden(); }).catch(fehler);
  };
  return (
    <section className="space-y-2" data-testid="massnahmen-zulassung">
      <h2 className="text-lg font-semibold">Maßnahmen &amp; AZAV-Zulassung</h2>
      <div className="bg-white rounded-xl border border-[#F0E6DC] divide-y divide-[#F6E3DA]">
        {liste.map((z) => (
          <div key={z.kurs_id} className="p-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={`zulassung-${z.kurs_id}`}>
            <span className="font-medium min-w-[220px]">{z.name}</span>
            <span className="text-[#78716c]">Nr. {z.massnahmenummer || "–"}</span>
            <span className="text-[#78716c]">{z.azav_zulassung_nummer || "kein AZAV-Zertifikat"}</span>
            <span className="text-[#78716c]">{de(z.zulassung_von)} – {de(z.zulassung_bis)}</span>
            <span className="ml-auto flex items-center gap-2">
              <Badge ton={ST[z.status][1]} testid={`zulassung-status-${z.kurs_id}`}>{ST[z.status][0]}</Badge>
              <Button size="sm" variant="ghost" onClick={() => aendern(z)} data-testid={`zulassung-aendern-${z.kurs_id}`}>Ändern</Button>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
